import { useAtom } from 'jotai';
import React, { FunctionComponent } from 'react';

import { CircularProgress, Typography } from '@mui/material';
import { Box } from '@mui/system';

import {
  currentPageIndexAtom,
  locationsAtom,
  refinersAtom,
  selectedLocationIdAtom,
  selectedRefinerItemsAtom,
  selectedSitesAtom,
  startRowAtom,
  useRefinerOverridesAtom,
  refinersExpandedAtom
} from '../utils/AtomConfig';
import Constants from '../utils/Constants';
import { useQuery } from 'react-query';
import { MdiService } from '../utils/MdiService';
import { Refiner } from './Refiner';

export const Refiners: FunctionComponent = () => {
  const mdiService = MdiService.Instance;
  const [selectedLocationId] = useAtom(selectedLocationIdAtom);
  const [locations] = useAtom(locationsAtom);
  const [selectedSites] = useAtom(selectedSitesAtom);
  const [useRefinerOverrides] = useAtom(useRefinerOverridesAtom);
  const [selectedRefinerItems, setselectedRefinerItems] = useAtom(selectedRefinerItemsAtom);
  const [, setRefiners] = useAtom(refinersAtom);
  const [, setCurrentPageIndex] = useAtom(currentPageIndexAtom);
  const [, setStartRow] = useAtom(startRowAtom);

  const refinerQuery = useQuery(
    [Constants.QUERY_KEYS.REFINERS, selectedLocationId],
    () => {
      const selectedLocation = locations.find(
        (location) => location.id === selectedLocationId
      );
      return mdiService.GetRefiners(selectedLocation?.title || '');
    },
    {
      ...Constants.BASE_DISABLE_REFETCH_SETTINGS,
      enabled: !!selectedLocationId,
      onSuccess: (data) => {
        setRefiners(data);
      },
    }
  );

  function handleClickClearFilters() {
    setCurrentPageIndex(1);
    setStartRow(0);
    setselectedRefinerItems([]);
  }

  const isAnyFiltersSelected = selectedRefinerItems.length > 0;
  const isLocationSelected = selectedLocationId !== Constants.DEFAULT_ID;

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography
          component='h2'
          variant='h5'
          sx={{ marginBottom: 1, color: '#003591' }}
        >
          Filter
        </Typography>

        {/* Only shows if there are any resources or item groups selected */}
        {isAnyFiltersSelected && (
          <Typography
            onClick={handleClickClearFilters}
            sx={{
              '&:hover': {
                cursor: 'pointer',
                textDecoration: 'underline',
              },
            }}
          >
            Clear filter
          </Typography>
        )}
      </Box>

      {/* Show message if location is not selected */}
      {!isLocationSelected && (
        <Typography align='center' color='black' marginTop={2}>
          Please select location first
        </Typography>
      )}

      {/* Show loading spinner */}
      {isLocationSelected && refinerQuery.isLoading && (
        <Box sx={{ marginTop: 3, textAlign: 'center' }}>
          <CircularProgress size={20} />
        </Box>
      )}

      {/* Dynamic refiners */}
      {refinerQuery.data &&
        refinerQuery.data.map((refiner) => (
          ((useRefinerOverrides && selectedSites[0] === refiner.siteId) || (!useRefinerOverrides && "All" === refiner.siteId)) && (
            <Refiner
              key={refiner.property}
              title={refiner.title}
              property={refiner.property}
            />
          )
        ))}

      {/* Show message if there are no refiners */}
      {isLocationSelected &&
        refinerQuery.data &&
        refinerQuery.data.length === 0 && (
          <Typography align='center' color='black' marginTop={2}>
            No refiners available for this location
          </Typography>
        )}
    </Box>
  );
};
